export enum TimeZoneType {
  local = 'local',
  GMT = 'gmt'
}
